import React from 'react';

import styles from './Main.module.css';
import MainCard from './MainCard';
import MainTop from './MainTop';
import SlideLogo from './SlideLogo';
import { Typography, Container } from '@mui/material';
import TextContent from '../../UI/TextContent';
import InQuiry from '../../banner/InQuiry';
import { ContainerFull } from '../../UI/ContentContainer';

import consulting from '../../../assets/img/컨설팅.jpg';
import Grid from '@mui/material/Unstable_Grid2/Grid2';



const Main = () => {

    return (
        <>
        <div className={styles.main_image}>
            <MainTop sx={{zIndex: "2"}}/>
        </div>
        <TextContent title="Business" variant="pageTitle">
            <Container maxWidth="sm" data-aos="fade-up">
                <Typography variant="description" textAlign="center" component="p">전문적인 지식과 경험으로 사업장의 안전 수준을 최상으로 유지할수 있도록 <br/>최선을 다하겠습니다.</Typography>
            </Container>
            <MainCard sx={{paddingTop: "90px"}}/>

        </TextContent>

        <ContainerFull>
            <Container maxWidth="md" data-aos="fade-up">
                <Typography variant="pageTitle" component="h3" textAlign="center">안전은 모두의 바람입니다</Typography>
                <Typography variant="description" component="p" textAlign="left">모든 직원, 고객, 협력사, 그리고 사회 구성원들에게 안전한 환경을 제공하는 것은 우리의 최우선 목표 중 하나입니다. </Typography>
                <Typography variant="description" component="p" textAlign="left">드림안전센터는 항상 안전성을 개선하고 함께 안전한 환경을 유지하기 위해 노력하고 있으며,  </Typography>
                <Typography variant="description" component="p" textAlign="left">우리의 모두의 이익을 위해 함께 협력하여 안전한 사업장을 만들어 나갈 것입니다.</Typography>
            </Container>
        </ContainerFull>

        <ContainerFull $backgroundColor="white">
            <Container maxWidth="lg" data-aos="fade-up">
                <Grid container spacing={2}>
                    <Grid xs={12} md={5}>
                        <img src={consulting} alt="consulting" style={{width: '100%', borderRadius: '20px'}}/>
                    </Grid>
                    <Grid xs={12} md={7}>
                        {/* <Typography variant="pageTitle" component="h3" >컨설팅</Typography> */}
                        <Typography variant="subTitle" component="h3">문제 해결과 성공을 위한 지혜와 전문 지식을 제공합니다</Typography>
                        <Typography variant="description" component="p">저희 드림안전센터는 다양한 분야에서 경험과 전문성을 바탕으로 고객들에게 특화된 솔루션을 제공하며, 비즈니스의 성장과 발전을 지원합니다. 컨설팅을 통해 고객과 협력하여 목표를 달성하고 끊임없는 개선을 추구합니다</Typography>
                    </Grid>
                </Grid>

            </Container>
        </ContainerFull>



        {/* <InQuiry maxWidth="md" data-aos="fade-up"/> */}

        </>
    )
}

export default Main;